import { get, isEmpty } from 'lodash';
import { AssortmentScopeSelectorSlice } from 'src/components/AssortmentScopeSelector/AssortmentScopeSelector.slice';
import { SubheaderSlice } from 'src/components/Subheader/Subheader.slice';
import { isWorklistActive } from 'src/services/configuration/codecs/confdefnComponents';
import { AppState } from 'src/store';

export function inputIsNotNullOrUndefined<T>(input: null | undefined | T | Array<null | undefined | T>): input is T {
  if (Array.isArray(input)) {
    return input.every(inputIsNotNullOrUndefined);
  }
  return input !== null && input !== undefined;
}

const getCurrentHideCompanion = (state: AppState) => get<AppState, string, boolean>(state, 'perspective.activePageConf.componentProps.hideCompanion', false);

/**
 * Currently, this just just checks for hideCompanion to determine if
 * top member is needed
 * @param state 
 * @returns 
 */
export function worklistNeedsTopMember(state: AppState) {
  const maybeHideCompanion = getCurrentHideCompanion(state);
  return isWorklistActive(state) && !maybeHideCompanion;
}


/** This function is used many places to check if we are ready to load a view that can be loaded in a worklist view as a subpage
 * It checks for multiple conditions:
 * 1. First, if we're in a worklist and have `hideCompanion: true`, then we don't care whether we have a selected item and can skip subsequent checks
 * 2. Next we check if (again kinda) if we're not in a worklist
 * 3. Then, if we're not hiding companion, we check if there is a selected item to be used
 */
export function topMemInWorklistSelected(state: AppState) {
  if (!worklistNeedsTopMember(state)) {
    return true;
  } else {
    // Otherwise, we need a selected item to be ready
    const activeBreadcrumbRestore = state.breadcrumbs.activeBreadcrumbRestore;
    const selectedItemId = state.worklist.selectedItemId;
    const maybeRestoredItemId = activeBreadcrumbRestore?.selectedCompanionId ?? selectedItemId;
    return !isEmpty(maybeRestoredItemId)
  }
}

/**
 * This returns queryParams. We need this as we store queryParams after anchor, which
 * is technically invalid url semantics.
 * @returns queryparams
 */
export function getUrlQueryParams() {
  const paramsStr = get(window.location.hash.split('?'), 1);
  if (paramsStr != null) {
    return new URLSearchParams(paramsStr);
  } else return null;
}

export function topMemInUrl() {
  const queryParams = getUrlQueryParams();
  if (queryParams != null) {
    return queryParams.get('topMember');
  }
  return queryParams;
}

export function isScopeDefined(scope: AssortmentScopeSelectorSlice) {
  return scope.scopeSelected;
}

export function isSubheaderLoaded(subheader: SubheaderSlice) {
  return !subheader.subheaderLoading;
}
